<template>
  <router-link
    :to="to"
    class="back_button"
    :class="{ 'back_button--block': block }"
  >
    <font-awesome-icon
      class="back_button__icon"
      :icon="['fas', 'chevron-left']"
    />
    <span v-if="!block">{{ label }}</span>
  </router-link>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronLeft);

export default {
  name: "BackButton",
  components: {
    FontAwesomeIcon,
  },
  props: {
    /**
     * @vuese
     * The Vue router object including the 'to' property.
     * That will configure where this button leads to.
     * Required.
     */
    to: {
      type: Object,
      required: true,
    },
    /**
     * The text that is shown in this button when the 'block' property is false.
     * Default: 'Back'.
     */
    label: {
      type: String,
      default: "Back",
    },
    /**
     * Block denotes the shape this button will take. Setting this to true will view
     * this component in an 1:1 aspect ratio block shape with only a caret pointing left.
     * Default: false.
     */
    block: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";

.back_button {
  @extend %body1_style;
  color: $blue;
  font-size: 1rem;
  text-decoration: none;
  font-weight: 600;

  span {
    padding-left: 12px;
  }

  &.back_button--block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    background-color: $white;
    border-radius: 3px;
    cursor: pointer;
    transition: all 36ms cubic-beziers(0.4, 0, 0.2, 1);

    &:hover {
      color: $blue_sapphire;
      background-color: $grey_alabaster;
    }
  }
}
</style>
